import api from '../utils/api'
import { API_ROOT } from '../constants'

export const downloadSite = (formData, config) => api.get(`${API_ROOT}/pro/download`, formData, undefined, config)

export const triggerDownloadRequest = (body, config) => api.post(`${API_ROOT}/v3/files/download-request`, body, config)

export const getDownloadRequestStatus = (id, config) =>
  api.get(`${API_ROOT}/v3/files/download-request/${id}`, undefined, undefined, config)

export const configureProAccount = (formData, config) => api.post(`${API_ROOT}/v3/subscription/setup`, formData, config)

export const configureTrialAccount = (formData, config) => api.post(`${API_ROOT}/v3/account/setup`, formData, config)

export const updateMetadata = (formData, config) => api.post(`${API_ROOT}/v3/account/update-metadata`, formData, config)

export const getSiteAnalytics = (formData, config) => api.get(`${API_ROOT}/v3/analytics/site`, formData, config)

export const getSitePageviews = (domain, config) => api.get(`${API_ROOT}/v3/get-site-pageviews/${domain}`, config)

export const switchPlan = (formData, config) => api.post(`${API_ROOT}/v3/subscription/upgrade`, formData, config)

export const cancelSubscription = (formData, config) => api.post(`${API_ROOT}/v3/subscription/cancel`, formData, config)

export const pauseSubscription = (formData, config) => api.post(`${API_ROOT}/v3/subscription/pause`, formData, config)

export const resumeSubscription = (formData, config) => api.post(`${API_ROOT}/v3/subscription/resume`, formData, config)

export const uncancelSubscription = (formData, config) =>
  api.post(`${API_ROOT}/v3/subscription/uncancel`, formData, config)

export const updateTeamMembers = (formData, config) => api.post(`${API_ROOT}/v3/account/manage-team`, formData, config)

export const manageBilling = (formData, config) =>
  api.post(`${API_ROOT}/v3/subscription/stripe/generate-billing-link`, formData, config)

export const getAPIKey = (formData, config) => api.get(`${API_ROOT}/v3/account/api-key`, formData, config)

export const getFileCode = (formData, config) => api.get(`${API_ROOT}/v3/editor/code`, formData, config)

export const claimSite = (formData, config) => api.post(`${API_ROOT}/v3/gpt/claim-site`, formData, config)

export const getPayProCheckoutUrl = (formData, config) =>
  api.post(`${API_ROOT}/v3/subscription/ppg/generate-checkout-url`, formData, config)

export const checkEligibleForDiscount = (formData, config) =>
  api.get(`${API_ROOT}/v3/subscription/discount-eligibility`, formData, config)

export const applyDiscountOffer = (formData, config) =>
  api.post(`${API_ROOT}/v3/subscription/apply-discount-offer`, formData, config)

export const fetchRepositories = (formData, config) => api.post(`${API_ROOT}/v3/github/repositories`, formData, config)

export const createGithubSite = async (formData, config) => api.post(`${API_ROOT}/v3/github/deploy`, formData, config)

export const requestToJoinTeam = (teamOwnerEmail) =>
  api.post(`${API_ROOT}/v3/account/request-team-join`, { teamOwnerEmail })

export const getTeamRequests = () => api.get(`${API_ROOT}/v3/account/team-requests`)

export const getPDFPageAnalytics = (params, config) => api.get(`${API_ROOT}/v3/analytics/pdf-page`, params, config)
export const updateAccountPassword = (formData, config) =>
  api.post(`${API_ROOT}/v3/account/update-password`, formData, config)
export const createAccount = (formData, config) => api.post(`${API_ROOT}/v3/account/create`, formData, config)
